export function selectAllPosts(state) {
  return state.post.all;
}
